import React from "react";
import { UserProfile } from "../UserAccess/UserContext";
import BusinessUserView from "./BusinessUserView";


const BusinessAdminView = ({ render }: { render: (profile: UserProfile) => JSX.Element }) =>
  <BusinessUserView render={profile => profile.selectedBusiness?.administrator
    ? render(profile)
    : <h1>Must be a business administrator to access this page</h1>} />

export default BusinessAdminView;
